import type { SubmissionRow } from "../api/helloAppClient.ts";
import { formatDate } from "../utils/formatDate.ts";

interface SubmissionsListProps {
  rows: SubmissionRow[];
}

export function SubmissionsList({ rows }: SubmissionsListProps) {
  if (rows.length === 0) {
    return (
      <div className="submissions-empty">
        <span className="submissions-empty__title">No submissions yet</span>
        <span>Your submissions will appear here once you send the first one.</span>
      </div>
    );
  }
  return (
    <ul className="submissions-list">
      {rows.map((row, i) => (
        <li key={`${row.submittedAt}-${i}`} className="submission">
          <header className="submission__header">
            <span className="submission__name">{row.name}</span>
            <time className="submission__time" dateTime={row.submittedAt}>
              {formatDate(row.submittedAt)}
            </time>
          </header>
          <p className="submission__message">{row.message}</p>
          {row.fileUrl ? (
            <a
              className="submission__attachment"
              href={row.fileUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <PaperclipIcon />
              {row.fileName || "Attachment"}
            </a>
          ) : null}
        </li>
      ))}
    </ul>
  );
}

function PaperclipIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
    </svg>
  );
}
